import React from 'react';
import { styled, Box, Typography, Divider } from '@mui/material';

export interface PageSectionProps {
  /** Section title */
  title?: string;
  /** Section description */
  description?: string;
  /** Section content */
  children: React.ReactNode;
  /** Show divider above section */
  divider?: boolean;
  /** Section actions (buttons, etc.) */
  actions?: React.ReactNode;
}

const SectionHeader = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const SectionTitleText = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

const SectionTitleActions = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
}));

const SectionDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

const SectionContent = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export const PageSection: React.FC<PageSectionProps> = ({
  title,
  description,
  children,
  divider = false,
  actions,
}) => {
  return (
    <>
      {divider && <Divider sx={{ my: 3 }} />}
      
      {(title || description) && (
        <SectionHeader>
          {title && (
            <SectionTitle variant="h5">
              <SectionTitleText>{title}</SectionTitleText>
              {actions && <SectionTitleActions>{actions}</SectionTitleActions>}
            </SectionTitle>
          )}
          
          {description && (
            <SectionDescription variant="body2">{description}</SectionDescription>
          )}
        </SectionHeader>
      )}
      
      <SectionContent>{children}</SectionContent>
    </>
  );
};

export default PageSection;
